import {
  Companion_getInstance14mfei2uzw3x6 as Companion_getInstance,
  PendingLineItem7uj25viy3ie8 as PendingLineItem,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  UUID21wrnrlmk5y1y as UUID,
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0,
} from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import {
  _MonetaryValue___init__impl__jsc11x21b8u6q6nd7yd as _MonetaryValue___init__impl__jsc11x,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  AccessInfoj60d6hx1qs8r as AccessInfo,
  AccessAndFeedback14j91frzc8fa0 as AccessAndFeedback,
} from './supportModels.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtSetjrjc7fhfd6b9 as KtSet,
} from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_created(_this__u8e3s4) {
  return _this__u8e3s4.prop(PendingLineItem_created_getInstance());
}
function get_changeRequest(_this__u8e3s4) {
  return _this__u8e3s4.prop(PendingLineItem_changeRequest_getInstance());
}
function get_itemNumber(_this__u8e3s4) {
  return _this__u8e3s4.prop(PendingLineItem_itemNumber_getInstance());
}
function get_linked(_this__u8e3s4) {
  return _this__u8e3s4.prop(PendingLineItem_linked_getInstance());
}
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(PendingLineItem_project_getInstance());
}
function preparePendingLineItemFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [PendingLineItem__id_getInstance(), PendingLineItem_project_getInstance(), PendingLineItem_changeRequest_getInstance(), PendingLineItem_name_getInstance(), PendingLineItem_description_getInstance(), PendingLineItem_price_getInstance(), PendingLineItem_files_getInstance(), PendingLineItem_linked_getInstance(), PendingLineItem_accepted_getInstance(), PendingLineItem_denied_getInstance(), PendingLineItem_withdrawn_getInstance(), PendingLineItem_approved_getInstance(), PendingLineItem_created_getInstance(), PendingLineItem_itemNumber_getInstance(), PendingLineItem_readBy_getInstance(), PendingLineItem_published_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function PendingLineItem_created$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(12);
}
function PendingLineItem_created$_get_name_$ref_a435ec() {
  return (p0) => p0.i20();
}
function PendingLineItem_created$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[12];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingLineItem_created$_get_serializer_$ref_nxv6it() {
  return (p0) => p0.h2j();
}
function PendingLineItem_created$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(12);
}
function PendingLineItem_created$_get_annotations_$ref_fr0zxb() {
  return (p0) => p0.bz();
}
var PendingLineItem_createdClass;
function PendingLineItem_created() {
  if (PendingLineItem_createdClass === VOID) {
    class $ {
      constructor() {
        PendingLineItem_created_instance = this;
        var tmp = this;
        tmp.n75_1 = lazy(PendingLineItem_created$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o75_1 = lazy(PendingLineItem_created$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p75_1 = lazy(PendingLineItem_created$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'com.lightningkite.now' call
        tmp_2.q75_1 = get_default(Companion_instance).b1m();
        this.r75_1 = 'now()';
      }
      i20() {
        var tmp0 = this.n75_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingLineItem_created$_get_name_$ref_a435ec(), null);
        return tmp0.f2();
      }
      s75(receiver) {
        return receiver.f76_1;
      }
      k2j(receiver) {
        return this.s75(receiver instanceof PendingLineItem() ? receiver : THROW_CCE());
      }
      j76(receiver, value) {
        return receiver.k76(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PendingLineItem() ? receiver : THROW_CCE();
        return this.j76(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.o75_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingLineItem_created$_get_serializer_$ref_nxv6it(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p75_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingLineItem_created$_get_annotations_$ref_fr0zxb(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingLineItem_created', VOID, VOID, [SerializableProperty()]);
    PendingLineItem_createdClass = $;
  }
  return PendingLineItem_createdClass;
}
var PendingLineItem_created_instance;
function PendingLineItem_created_getInstance() {
  if (PendingLineItem_created_instance === VOID)
    new (PendingLineItem_created())();
  return PendingLineItem_created_instance;
}
function PendingLineItem_changeRequest$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function PendingLineItem_changeRequest$_get_name_$ref_ar81v9() {
  return (p0) => p0.i20();
}
function PendingLineItem_changeRequest$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingLineItem_changeRequest$_get_serializer_$ref_c8qmq6() {
  return (p0) => p0.h2j();
}
function PendingLineItem_changeRequest$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function PendingLineItem_changeRequest$_get_annotations_$ref_89o852() {
  return (p0) => p0.bz();
}
var PendingLineItem_changeRequestClass;
function PendingLineItem_changeRequest() {
  if (PendingLineItem_changeRequestClass === VOID) {
    class $ {
      constructor() {
        PendingLineItem_changeRequest_instance = this;
        var tmp = this;
        tmp.l76_1 = lazy(PendingLineItem_changeRequest$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m76_1 = lazy(PendingLineItem_changeRequest$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n76_1 = lazy(PendingLineItem_changeRequest$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.l76_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingLineItem_changeRequest$_get_name_$ref_ar81v9(), null);
        return tmp0.f2();
      }
      s75(receiver) {
        return receiver.v75_1;
      }
      k2j(receiver) {
        return this.s75(receiver instanceof PendingLineItem() ? receiver : THROW_CCE());
      }
      o76(receiver, value) {
        return receiver.k76(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PendingLineItem() ? receiver : THROW_CCE();
        return this.o76(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.m76_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingLineItem_changeRequest$_get_serializer_$ref_c8qmq6(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n76_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingLineItem_changeRequest$_get_annotations_$ref_89o852(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingLineItem_changeRequest', VOID, VOID, [SerializableProperty()]);
    PendingLineItem_changeRequestClass = $;
  }
  return PendingLineItem_changeRequestClass;
}
var PendingLineItem_changeRequest_instance;
function PendingLineItem_changeRequest_getInstance() {
  if (PendingLineItem_changeRequest_instance === VOID)
    new (PendingLineItem_changeRequest())();
  return PendingLineItem_changeRequest_instance;
}
function PendingLineItem_itemNumber$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(13);
}
function PendingLineItem_itemNumber$_get_name_$ref_p8js22() {
  return (p0) => p0.i20();
}
function PendingLineItem_itemNumber$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[13];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingLineItem_itemNumber$_get_serializer_$ref_5ko1o1() {
  return (p0) => p0.h2j();
}
function PendingLineItem_itemNumber$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(13);
}
function PendingLineItem_itemNumber$_get_annotations_$ref_o6xnpx() {
  return (p0) => p0.bz();
}
var PendingLineItem_itemNumberClass;
function PendingLineItem_itemNumber() {
  if (PendingLineItem_itemNumberClass === VOID) {
    class $ {
      constructor() {
        PendingLineItem_itemNumber_instance = this;
        var tmp = this;
        tmp.p76_1 = lazy(PendingLineItem_itemNumber$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q76_1 = lazy(PendingLineItem_itemNumber$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r76_1 = lazy(PendingLineItem_itemNumber$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.p76_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingLineItem_itemNumber$_get_name_$ref_p8js22(), null);
        return tmp0.f2();
      }
      s75(receiver) {
        return receiver.g76_1;
      }
      k2j(receiver) {
        return this.s75(receiver instanceof PendingLineItem() ? receiver : THROW_CCE());
      }
      s76(receiver, value) {
        return receiver.k76(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PendingLineItem() ? receiver : THROW_CCE();
        return this.s76(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.q76_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingLineItem_itemNumber$_get_serializer_$ref_5ko1o1(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r76_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingLineItem_itemNumber$_get_annotations_$ref_o6xnpx(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingLineItem_itemNumber', VOID, VOID, [SerializableProperty()]);
    PendingLineItem_itemNumberClass = $;
  }
  return PendingLineItem_itemNumberClass;
}
var PendingLineItem_itemNumber_instance;
function PendingLineItem_itemNumber_getInstance() {
  if (PendingLineItem_itemNumber_instance === VOID)
    new (PendingLineItem_itemNumber())();
  return PendingLineItem_itemNumber_instance;
}
function PendingLineItem_linked$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(7);
}
function PendingLineItem_linked$_get_name_$ref_isc3zt() {
  return (p0) => p0.i20();
}
function PendingLineItem_linked$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingLineItem_linked$_get_serializer_$ref_41aixe() {
  return (p0) => p0.h2j();
}
function PendingLineItem_linked$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(7);
}
function PendingLineItem_linked$_get_annotations_$ref_x1uvpq() {
  return (p0) => p0.bz();
}
var PendingLineItem_linkedClass;
function PendingLineItem_linked() {
  if (PendingLineItem_linkedClass === VOID) {
    class $ {
      constructor() {
        PendingLineItem_linked_instance = this;
        var tmp = this;
        tmp.t76_1 = lazy(PendingLineItem_linked$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u76_1 = lazy(PendingLineItem_linked$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v76_1 = lazy(PendingLineItem_linked$annotations$delegate$lambda);
        this.w76_1 = false;
        this.x76_1 = 'false';
      }
      i20() {
        var tmp0 = this.t76_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingLineItem_linked$_get_name_$ref_isc3zt(), null);
        return tmp0.f2();
      }
      s75(receiver) {
        return receiver.a76_1;
      }
      k2j(receiver) {
        return this.s75(receiver instanceof PendingLineItem() ? receiver : THROW_CCE());
      }
      y76(receiver, value) {
        return receiver.k76(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PendingLineItem() ? receiver : THROW_CCE();
        return this.y76(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.u76_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingLineItem_linked$_get_serializer_$ref_41aixe(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v76_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingLineItem_linked$_get_annotations_$ref_x1uvpq(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingLineItem_linked', VOID, VOID, [SerializableProperty()]);
    PendingLineItem_linkedClass = $;
  }
  return PendingLineItem_linkedClass;
}
var PendingLineItem_linked_instance;
function PendingLineItem_linked_getInstance() {
  if (PendingLineItem_linked_instance === VOID)
    new (PendingLineItem_linked())();
  return PendingLineItem_linked_instance;
}
function PendingLineItem_project$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function PendingLineItem_project$_get_name_$ref_5ute1x() {
  return (p0) => p0.i20();
}
function PendingLineItem_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingLineItem_project$_get_serializer_$ref_oondis() {
  return (p0) => p0.h2j();
}
function PendingLineItem_project$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function PendingLineItem_project$_get_annotations_$ref_w7t12o() {
  return (p0) => p0.bz();
}
var PendingLineItem_projectClass;
function PendingLineItem_project() {
  if (PendingLineItem_projectClass === VOID) {
    class $ {
      constructor() {
        PendingLineItem_project_instance = this;
        var tmp = this;
        tmp.z76_1 = lazy(PendingLineItem_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a77_1 = lazy(PendingLineItem_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b77_1 = lazy(PendingLineItem_project$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.z76_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingLineItem_project$_get_name_$ref_5ute1x(), null);
        return tmp0.f2();
      }
      s75(receiver) {
        return receiver.u75_1;
      }
      k2j(receiver) {
        return this.s75(receiver instanceof PendingLineItem() ? receiver : THROW_CCE());
      }
      o76(receiver, value) {
        return receiver.k76(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PendingLineItem() ? receiver : THROW_CCE();
        return this.o76(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.a77_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingLineItem_project$_get_serializer_$ref_oondis(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b77_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingLineItem_project$_get_annotations_$ref_w7t12o(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingLineItem_project', VOID, VOID, [SerializableProperty()]);
    PendingLineItem_projectClass = $;
  }
  return PendingLineItem_projectClass;
}
var PendingLineItem_project_instance;
function PendingLineItem_project_getInstance() {
  if (PendingLineItem_project_instance === VOID)
    new (PendingLineItem_project())();
  return PendingLineItem_project_instance;
}
function PendingLineItem__id$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function PendingLineItem__id$_get_name_$ref_f6cn8m() {
  return (p0) => p0.i20();
}
function PendingLineItem__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingLineItem__id$_get_serializer_$ref_oorw3x() {
  return (p0) => p0.h2j();
}
function PendingLineItem__id$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function PendingLineItem__id$_get_annotations_$ref_3h45r() {
  return (p0) => p0.bz();
}
var PendingLineItem__idClass;
function PendingLineItem__id() {
  if (PendingLineItem__idClass === VOID) {
    class $ {
      constructor() {
        PendingLineItem__id_instance = this;
        var tmp = this;
        tmp.c77_1 = lazy(PendingLineItem__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d77_1 = lazy(PendingLineItem__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e77_1 = lazy(PendingLineItem__id$annotations$delegate$lambda);
        this.f77_1 = Companion_getInstance_0().k2p();
        this.g77_1 = 'UUID.random()';
      }
      i20() {
        var tmp0 = this.c77_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingLineItem__id$_get_name_$ref_f6cn8m(), null);
        return tmp0.f2();
      }
      s75(receiver) {
        return receiver.t75_1;
      }
      k2j(receiver) {
        return this.s75(receiver instanceof PendingLineItem() ? receiver : THROW_CCE());
      }
      o76(receiver, value) {
        return receiver.k76(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PendingLineItem() ? receiver : THROW_CCE();
        return this.o76(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.d77_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingLineItem__id$_get_serializer_$ref_oorw3x(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e77_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingLineItem__id$_get_annotations_$ref_3h45r(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingLineItem__id', VOID, VOID, [SerializableProperty()]);
    PendingLineItem__idClass = $;
  }
  return PendingLineItem__idClass;
}
var PendingLineItem__id_instance;
function PendingLineItem__id_getInstance() {
  if (PendingLineItem__id_instance === VOID)
    new (PendingLineItem__id())();
  return PendingLineItem__id_instance;
}
function PendingLineItem_name$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(3);
}
function PendingLineItem_name$_get_name_$ref_kms8jr() {
  return (p0) => p0.i20();
}
function PendingLineItem_name$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingLineItem_name$_get_serializer_$ref_uh7dnk() {
  return (p0) => p0.h2j();
}
function PendingLineItem_name$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(3);
}
function PendingLineItem_name$_get_annotations_$ref_5b6z38() {
  return (p0) => p0.bz();
}
var PendingLineItem_nameClass;
function PendingLineItem_name() {
  if (PendingLineItem_nameClass === VOID) {
    class $ {
      constructor() {
        PendingLineItem_name_instance = this;
        var tmp = this;
        tmp.h77_1 = lazy(PendingLineItem_name$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i77_1 = lazy(PendingLineItem_name$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j77_1 = lazy(PendingLineItem_name$annotations$delegate$lambda);
        this.k77_1 = '';
        this.l77_1 = '""';
      }
      i20() {
        var tmp0 = this.h77_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingLineItem_name$_get_name_$ref_kms8jr(), null);
        return tmp0.f2();
      }
      s75(receiver) {
        return receiver.w75_1;
      }
      k2j(receiver) {
        return this.s75(receiver instanceof PendingLineItem() ? receiver : THROW_CCE());
      }
      s76(receiver, value) {
        return receiver.k76(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PendingLineItem() ? receiver : THROW_CCE();
        return this.s76(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.i77_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingLineItem_name$_get_serializer_$ref_uh7dnk(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j77_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingLineItem_name$_get_annotations_$ref_5b6z38(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingLineItem_name', VOID, VOID, [SerializableProperty()]);
    PendingLineItem_nameClass = $;
  }
  return PendingLineItem_nameClass;
}
var PendingLineItem_name_instance;
function PendingLineItem_name_getInstance() {
  if (PendingLineItem_name_instance === VOID)
    new (PendingLineItem_name())();
  return PendingLineItem_name_instance;
}
function PendingLineItem_description$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(4);
}
function PendingLineItem_description$_get_name_$ref_d2lxd4() {
  return (p0) => p0.i20();
}
function PendingLineItem_description$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingLineItem_description$_get_serializer_$ref_8ogl2p() {
  return (p0) => p0.h2j();
}
function PendingLineItem_description$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(4);
}
function PendingLineItem_description$_get_annotations_$ref_v5v53h() {
  return (p0) => p0.bz();
}
var PendingLineItem_descriptionClass;
function PendingLineItem_description() {
  if (PendingLineItem_descriptionClass === VOID) {
    class $ {
      constructor() {
        PendingLineItem_description_instance = this;
        var tmp = this;
        tmp.m77_1 = lazy(PendingLineItem_description$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n77_1 = lazy(PendingLineItem_description$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o77_1 = lazy(PendingLineItem_description$annotations$delegate$lambda);
        this.p77_1 = '';
        this.q77_1 = '""';
      }
      i20() {
        var tmp0 = this.m77_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingLineItem_description$_get_name_$ref_d2lxd4(), null);
        return tmp0.f2();
      }
      s75(receiver) {
        return receiver.x75_1;
      }
      k2j(receiver) {
        return this.s75(receiver instanceof PendingLineItem() ? receiver : THROW_CCE());
      }
      s76(receiver, value) {
        return receiver.k76(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PendingLineItem() ? receiver : THROW_CCE();
        return this.s76(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.n77_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingLineItem_description$_get_serializer_$ref_8ogl2p(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o77_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingLineItem_description$_get_annotations_$ref_v5v53h(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingLineItem_description', VOID, VOID, [SerializableProperty()]);
    PendingLineItem_descriptionClass = $;
  }
  return PendingLineItem_descriptionClass;
}
var PendingLineItem_description_instance;
function PendingLineItem_description_getInstance() {
  if (PendingLineItem_description_instance === VOID)
    new (PendingLineItem_description())();
  return PendingLineItem_description_instance;
}
function PendingLineItem_price$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(5);
}
function PendingLineItem_price$_get_name_$ref_4847dh() {
  return (p0) => p0.i20();
}
function PendingLineItem_price$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingLineItem_price$_get_serializer_$ref_lg57b8() {
  return (p0) => p0.h2j();
}
function PendingLineItem_price$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(5);
}
function PendingLineItem_price$_get_annotations_$ref_9irqdc() {
  return (p0) => p0.bz();
}
var PendingLineItem_priceClass;
function PendingLineItem_price() {
  if (PendingLineItem_priceClass === VOID) {
    class $ {
      constructor() {
        PendingLineItem_price_instance = this;
        var tmp = this;
        tmp.r77_1 = lazy(PendingLineItem_price$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.s77_1 = lazy(PendingLineItem_price$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.t77_1 = lazy(PendingLineItem_price$annotations$delegate$lambda);
        this.u77_1 = _MonetaryValue___init__impl__jsc11x(0n);
        this.v77_1 = 'MonetaryValue(0L)';
      }
      i20() {
        var tmp0 = this.r77_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingLineItem_price$_get_name_$ref_4847dh(), null);
        return tmp0.f2();
      }
      w77(receiver) {
        return receiver.y75_1;
      }
      k2j(receiver) {
        return new (MonetaryValue())(this.w77(receiver instanceof PendingLineItem() ? receiver : THROW_CCE()));
      }
      x77(receiver, value) {
        return receiver.k76(VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PendingLineItem() ? receiver : THROW_CCE();
        return this.x77(tmp, value instanceof MonetaryValue() ? value.y5r_1 : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.s77_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingLineItem_price$_get_serializer_$ref_lg57b8(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.t77_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingLineItem_price$_get_annotations_$ref_9irqdc(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingLineItem_price', VOID, VOID, [SerializableProperty()]);
    PendingLineItem_priceClass = $;
  }
  return PendingLineItem_priceClass;
}
var PendingLineItem_price_instance;
function PendingLineItem_price_getInstance() {
  if (PendingLineItem_price_instance === VOID)
    new (PendingLineItem_price())();
  return PendingLineItem_price_instance;
}
function PendingLineItem_files$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(6);
}
function PendingLineItem_files$_get_name_$ref_4v2k3n() {
  return (p0) => p0.i20();
}
function PendingLineItem_files$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingLineItem_files$_get_serializer_$ref_xiyy8m() {
  return (p0) => p0.h2j();
}
function PendingLineItem_files$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(6);
}
function PendingLineItem_files$_get_annotations_$ref_sstn8u() {
  return (p0) => p0.bz();
}
var PendingLineItem_filesClass;
function PendingLineItem_files() {
  if (PendingLineItem_filesClass === VOID) {
    class $ {
      constructor() {
        PendingLineItem_files_instance = this;
        var tmp = this;
        tmp.y77_1 = lazy(PendingLineItem_files$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z77_1 = lazy(PendingLineItem_files$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a78_1 = lazy(PendingLineItem_files$annotations$delegate$lambda);
        var tmp_2 = this;
        // Inline function 'kotlin.collections.listOf' call
        tmp_2.b78_1 = emptyList();
        this.c78_1 = 'listOf()';
      }
      i20() {
        var tmp0 = this.y77_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingLineItem_files$_get_name_$ref_4v2k3n(), null);
        return tmp0.f2();
      }
      s75(receiver) {
        return receiver.z75_1;
      }
      k2j(receiver) {
        return this.s75(receiver instanceof PendingLineItem() ? receiver : THROW_CCE());
      }
      d78(receiver, value) {
        return receiver.k76(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PendingLineItem() ? receiver : THROW_CCE();
        return this.d78(tmp, (!(value == null) ? isInterface(value, KtList()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.z77_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingLineItem_files$_get_serializer_$ref_xiyy8m(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a78_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingLineItem_files$_get_annotations_$ref_sstn8u(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingLineItem_files', VOID, VOID, [SerializableProperty()]);
    PendingLineItem_filesClass = $;
  }
  return PendingLineItem_filesClass;
}
var PendingLineItem_files_instance;
function PendingLineItem_files_getInstance() {
  if (PendingLineItem_files_instance === VOID)
    new (PendingLineItem_files())();
  return PendingLineItem_files_instance;
}
function PendingLineItem_accepted$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(8);
}
function PendingLineItem_accepted$_get_name_$ref_vplfpx() {
  return (p0) => p0.i20();
}
function PendingLineItem_accepted$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingLineItem_accepted$_get_serializer_$ref_f625a4() {
  return (p0) => p0.h2j();
}
function PendingLineItem_accepted$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(8);
}
function PendingLineItem_accepted$_get_annotations_$ref_aw8rls() {
  return (p0) => p0.bz();
}
var PendingLineItem_acceptedClass;
function PendingLineItem_accepted() {
  if (PendingLineItem_acceptedClass === VOID) {
    class $ {
      constructor() {
        PendingLineItem_accepted_instance = this;
        var tmp = this;
        tmp.e78_1 = lazy(PendingLineItem_accepted$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f78_1 = lazy(PendingLineItem_accepted$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g78_1 = lazy(PendingLineItem_accepted$annotations$delegate$lambda);
        this.h78_1 = null;
        this.i78_1 = 'null';
      }
      i20() {
        var tmp0 = this.e78_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingLineItem_accepted$_get_name_$ref_vplfpx(), null);
        return tmp0.f2();
      }
      s75(receiver) {
        return receiver.b76_1;
      }
      k2j(receiver) {
        return this.s75(receiver instanceof PendingLineItem() ? receiver : THROW_CCE());
      }
      j78(receiver, value) {
        return receiver.k76(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PendingLineItem() ? receiver : THROW_CCE();
        return this.j78(tmp, (value == null ? true : value instanceof AccessInfo()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.f78_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingLineItem_accepted$_get_serializer_$ref_f625a4(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g78_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingLineItem_accepted$_get_annotations_$ref_aw8rls(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingLineItem_accepted', VOID, VOID, [SerializableProperty()]);
    PendingLineItem_acceptedClass = $;
  }
  return PendingLineItem_acceptedClass;
}
var PendingLineItem_accepted_instance;
function PendingLineItem_accepted_getInstance() {
  if (PendingLineItem_accepted_instance === VOID)
    new (PendingLineItem_accepted())();
  return PendingLineItem_accepted_instance;
}
function PendingLineItem_denied$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(9);
}
function PendingLineItem_denied$_get_name_$ref_k6ka6h() {
  return (p0) => p0.i20();
}
function PendingLineItem_denied$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingLineItem_denied$_get_serializer_$ref_j19r80() {
  return (p0) => p0.h2j();
}
function PendingLineItem_denied$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(9);
}
function PendingLineItem_denied$_get_annotations_$ref_5qsxkk() {
  return (p0) => p0.bz();
}
var PendingLineItem_deniedClass;
function PendingLineItem_denied() {
  if (PendingLineItem_deniedClass === VOID) {
    class $ {
      constructor() {
        PendingLineItem_denied_instance = this;
        var tmp = this;
        tmp.k78_1 = lazy(PendingLineItem_denied$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.l78_1 = lazy(PendingLineItem_denied$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.m78_1 = lazy(PendingLineItem_denied$annotations$delegate$lambda);
        this.n78_1 = null;
        this.o78_1 = 'null';
      }
      i20() {
        var tmp0 = this.k78_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingLineItem_denied$_get_name_$ref_k6ka6h(), null);
        return tmp0.f2();
      }
      s75(receiver) {
        return receiver.c76_1;
      }
      k2j(receiver) {
        return this.s75(receiver instanceof PendingLineItem() ? receiver : THROW_CCE());
      }
      p78(receiver, value) {
        return receiver.k76(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PendingLineItem() ? receiver : THROW_CCE();
        return this.p78(tmp, (value == null ? true : value instanceof AccessAndFeedback()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.l78_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingLineItem_denied$_get_serializer_$ref_j19r80(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.m78_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingLineItem_denied$_get_annotations_$ref_5qsxkk(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingLineItem_denied', VOID, VOID, [SerializableProperty()]);
    PendingLineItem_deniedClass = $;
  }
  return PendingLineItem_deniedClass;
}
var PendingLineItem_denied_instance;
function PendingLineItem_denied_getInstance() {
  if (PendingLineItem_denied_instance === VOID)
    new (PendingLineItem_denied())();
  return PendingLineItem_denied_instance;
}
function PendingLineItem_withdrawn$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(10);
}
function PendingLineItem_withdrawn$_get_name_$ref_dcsi28() {
  return (p0) => p0.i20();
}
function PendingLineItem_withdrawn$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingLineItem_withdrawn$_get_serializer_$ref_1v7fsn() {
  return (p0) => p0.h2j();
}
function PendingLineItem_withdrawn$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(10);
}
function PendingLineItem_withdrawn$_get_annotations_$ref_2xzm79() {
  return (p0) => p0.bz();
}
var PendingLineItem_withdrawnClass;
function PendingLineItem_withdrawn() {
  if (PendingLineItem_withdrawnClass === VOID) {
    class $ {
      constructor() {
        PendingLineItem_withdrawn_instance = this;
        var tmp = this;
        tmp.q78_1 = lazy(PendingLineItem_withdrawn$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r78_1 = lazy(PendingLineItem_withdrawn$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s78_1 = lazy(PendingLineItem_withdrawn$annotations$delegate$lambda);
        this.t78_1 = null;
        this.u78_1 = 'null';
      }
      i20() {
        var tmp0 = this.q78_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingLineItem_withdrawn$_get_name_$ref_dcsi28(), null);
        return tmp0.f2();
      }
      s75(receiver) {
        return receiver.d76_1;
      }
      k2j(receiver) {
        return this.s75(receiver instanceof PendingLineItem() ? receiver : THROW_CCE());
      }
      v78(receiver, value) {
        return receiver.k76(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PendingLineItem() ? receiver : THROW_CCE();
        return this.v78(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.r78_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingLineItem_withdrawn$_get_serializer_$ref_1v7fsn(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s78_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingLineItem_withdrawn$_get_annotations_$ref_2xzm79(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingLineItem_withdrawn', VOID, VOID, [SerializableProperty()]);
    PendingLineItem_withdrawnClass = $;
  }
  return PendingLineItem_withdrawnClass;
}
var PendingLineItem_withdrawn_instance;
function PendingLineItem_withdrawn_getInstance() {
  if (PendingLineItem_withdrawn_instance === VOID)
    new (PendingLineItem_withdrawn())();
  return PendingLineItem_withdrawn_instance;
}
function PendingLineItem_approved$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(11);
}
function PendingLineItem_approved$_get_name_$ref_y4zkyt() {
  return (p0) => p0.i20();
}
function PendingLineItem_approved$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[11];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingLineItem_approved$_get_serializer_$ref_xjv9o4() {
  return (p0) => p0.h2j();
}
function PendingLineItem_approved$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(11);
}
function PendingLineItem_approved$_get_annotations_$ref_tknhlc() {
  return (p0) => p0.bz();
}
var PendingLineItem_approvedClass;
function PendingLineItem_approved() {
  if (PendingLineItem_approvedClass === VOID) {
    class $ {
      constructor() {
        PendingLineItem_approved_instance = this;
        var tmp = this;
        tmp.w78_1 = lazy(PendingLineItem_approved$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x78_1 = lazy(PendingLineItem_approved$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y78_1 = lazy(PendingLineItem_approved$annotations$delegate$lambda);
        this.z78_1 = null;
        this.a79_1 = 'null';
      }
      i20() {
        var tmp0 = this.w78_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingLineItem_approved$_get_name_$ref_y4zkyt(), null);
        return tmp0.f2();
      }
      s75(receiver) {
        return receiver.e76_1;
      }
      k2j(receiver) {
        return this.s75(receiver instanceof PendingLineItem() ? receiver : THROW_CCE());
      }
      b79(receiver, value) {
        return receiver.k76(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PendingLineItem() ? receiver : THROW_CCE();
        return this.b79(tmp, (value == null ? true : typeof value === 'boolean') ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.x78_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingLineItem_approved$_get_serializer_$ref_xjv9o4(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y78_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingLineItem_approved$_get_annotations_$ref_tknhlc(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingLineItem_approved', VOID, VOID, [SerializableProperty()]);
    PendingLineItem_approvedClass = $;
  }
  return PendingLineItem_approvedClass;
}
var PendingLineItem_approved_instance;
function PendingLineItem_approved_getInstance() {
  if (PendingLineItem_approved_instance === VOID)
    new (PendingLineItem_approved())();
  return PendingLineItem_approved_instance;
}
function PendingLineItem_readBy$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(14);
}
function PendingLineItem_readBy$_get_name_$ref_sm64e3() {
  return (p0) => p0.i20();
}
function PendingLineItem_readBy$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[14];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingLineItem_readBy$_get_serializer_$ref_o7kxpe() {
  return (p0) => p0.h2j();
}
function PendingLineItem_readBy$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(14);
}
function PendingLineItem_readBy$_get_annotations_$ref_epiicm() {
  return (p0) => p0.bz();
}
var PendingLineItem_readByClass;
function PendingLineItem_readBy() {
  if (PendingLineItem_readByClass === VOID) {
    class $ {
      constructor() {
        PendingLineItem_readBy_instance = this;
        var tmp = this;
        tmp.c79_1 = lazy(PendingLineItem_readBy$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d79_1 = lazy(PendingLineItem_readBy$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e79_1 = lazy(PendingLineItem_readBy$annotations$delegate$lambda);
        this.f79_1 = emptySet();
        this.g79_1 = 'emptySet()';
      }
      i20() {
        var tmp0 = this.c79_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingLineItem_readBy$_get_name_$ref_sm64e3(), null);
        return tmp0.f2();
      }
      s75(receiver) {
        return receiver.h76_1;
      }
      k2j(receiver) {
        return this.s75(receiver instanceof PendingLineItem() ? receiver : THROW_CCE());
      }
      h79(receiver, value) {
        return receiver.k76(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PendingLineItem() ? receiver : THROW_CCE();
        return this.h79(tmp, (!(value == null) ? isInterface(value, KtSet()) : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.d79_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingLineItem_readBy$_get_serializer_$ref_o7kxpe(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e79_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingLineItem_readBy$_get_annotations_$ref_epiicm(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingLineItem_readBy', VOID, VOID, [SerializableProperty()]);
    PendingLineItem_readByClass = $;
  }
  return PendingLineItem_readByClass;
}
var PendingLineItem_readBy_instance;
function PendingLineItem_readBy_getInstance() {
  if (PendingLineItem_readBy_instance === VOID)
    new (PendingLineItem_readBy())();
  return PendingLineItem_readBy_instance;
}
function PendingLineItem_published$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(15);
}
function PendingLineItem_published$_get_name_$ref_izgly2() {
  return (p0) => p0.i20();
}
function PendingLineItem_published$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[15];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function PendingLineItem_published$_get_serializer_$ref_cb7g01() {
  return (p0) => p0.h2j();
}
function PendingLineItem_published$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(15);
}
function PendingLineItem_published$_get_annotations_$ref_sfkhb9() {
  return (p0) => p0.bz();
}
var PendingLineItem_publishedClass;
function PendingLineItem_published() {
  if (PendingLineItem_publishedClass === VOID) {
    class $ {
      constructor() {
        PendingLineItem_published_instance = this;
        var tmp = this;
        tmp.i79_1 = lazy(PendingLineItem_published$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.j79_1 = lazy(PendingLineItem_published$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.k79_1 = lazy(PendingLineItem_published$annotations$delegate$lambda);
        this.l79_1 = null;
        this.m79_1 = 'null';
      }
      i20() {
        var tmp0 = this.i79_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, PendingLineItem_published$_get_name_$ref_izgly2(), null);
        return tmp0.f2();
      }
      s75(receiver) {
        return receiver.i76_1;
      }
      k2j(receiver) {
        return this.s75(receiver instanceof PendingLineItem() ? receiver : THROW_CCE());
      }
      v78(receiver, value) {
        return receiver.k76(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof PendingLineItem() ? receiver : THROW_CCE();
        return this.v78(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.j79_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, PendingLineItem_published$_get_serializer_$ref_cb7g01(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.k79_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, PendingLineItem_published$_get_annotations_$ref_sfkhb9(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'PendingLineItem_published', VOID, VOID, [SerializableProperty()]);
    PendingLineItem_publishedClass = $;
  }
  return PendingLineItem_publishedClass;
}
var PendingLineItem_published_instance;
function PendingLineItem_published_getInstance() {
  if (PendingLineItem_published_instance === VOID)
    new (PendingLineItem_published())();
  return PendingLineItem_published_instance;
}
//region block: exports
export {
  get_changeRequest as get_changeRequest1kn1g9zivscde,
  get_created as get_created3km9fnevcxvgw,
  get_itemNumber as get_itemNumber2q6tr7iizmkdb,
  get_linked as get_linkedwb9jodr9vc0,
  preparePendingLineItemFields as preparePendingLineItemFields1ph1cetuo0itc,
  get_project as get_projectgc591kstp7s4,
};
//endregion

//# sourceMappingURL=PendingLineItemFields.mjs.map
